import { render, staticRenderFns } from "./side-panel.vue?vue&type=template&id=55e33dbd&scoped=true&"
import script from "./side-panel.vue?vue&type=script&lang=js&"
export * from "./side-panel.vue?vue&type=script&lang=js&"
import style0 from "./side-panel.vue?vue&type=style&index=0&id=55e33dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e33dbd",
  null
  
)

component.options.__file = "side-panel.vue"
export default component.exports